import { create } from '@bufbuild/protobuf'
import { useQuery } from '@connectrpc/connect-query'
import type { WorkflowAutoCreationRuleNoticeEntry } from '@ebalance/proto/bffuser/v1/global_alert_model_pb'
import {
  GlobalAlertService,
  ListWorkflowAutoCreationNoticesRequestSchema,
} from '@ebalance/proto/bffuser/v1/global_alert_service_pb'

import {
  SIDE_MENU_DOT_QUERY_OPTIONS,
  freshSideMenuDotData,
} from '~/hooks/sideMenuDotQuery'

const EMPTY: readonly WorkflowAutoCreationRuleNoticeEntry[] = []

/**
 * 起票していない自動起票ルール (AC-SC-044 / AC-WFT-050)。layout の `SideMenuDotsProvider` が
 * 1 か所で呼ぶ。組織は BFF が認証セッションから決め、flag が OFF の組織には backend が空を返す。
 * 取得方針は `sideMenuDotQuery` が持ち、取得中・取得失敗・オフラインで保留中は空にする。
 */
export function useWorkflowAutoCreationNotices(): {
  rules: readonly WorkflowAutoCreationRuleNoticeEntry[]
} {
  const query = useQuery(
    GlobalAlertService.method.listWorkflowAutoCreationNotices,
    create(ListWorkflowAutoCreationNoticesRequestSchema, {}),
    SIDE_MENU_DOT_QUERY_OPTIONS,
  )
  const data = freshSideMenuDotData(query)
  return { rules: data === undefined ? EMPTY : data.rules }
}
